import styled from 'styled-components';

export const FlexFill = styled.div`
  display: flex;
  flex: 1;
`;

// used to replace the legacy icon with type as ''
export const EmptyIcon =  styled.span`
  padding: 10px;
`;


